import { create } from "zustand";

const initialState = {
  data: [],
  loading: false,
  openModal: false,
  additionalEmailTypes: [],
  additionalPhoneTypes: [],
  communicationPreferenceTypes: [],
  activeStates: [],
  disableCancelButton: true,
  disableSaveButton: true,
  initialData: {},
  modifiedData: {},
  minProviderTypes: 0,
  maxProviderTypes: Number.MAX_SAFE_INTEGER,
  booleanOptionsData: [
    { id: true, label: "Yes" },
    { id: false, label: "No" },
  ],
};

export const useProviderDetailStore = create((set) => ({
  ...initialState,

  setData: (data) => set({ data }),
  setLoading: (value) => set({ loading: value }),
  setOpenModal: (value) => set({ openModal: value }),
  setAdditionalEmailTypes: (additionalEmailTypes) => set({ additionalEmailTypes }),
  setAdditionalPhoneTypes: (additionalPhoneTypes) => set({ additionalPhoneTypes }),
  setCommunicationPreferenceTypes: (communicationPreferenceTypes) =>
    set({ communicationPreferenceTypes }),
  setActiveStates: (activeStates) => set({ activeStates }),
  setDisableCancelButton: (value) => set({ disableCancelButton: value }),
  setDisableSaveButton: (value) => set({ disableSaveButton: value }),

  setInitialData: (initialData) => set({ initialData }),
  setModifiedData: (modifiedData) => set({ modifiedData }),
  setMinProviderTypes: (minProviderTypes) => set({ minProviderTypes }),
  setMaxProviderTypes: (maxProviderTypes) => set({ maxProviderTypes }),
  setProviderTypesRange: (min, max) => set({ minProviderTypes: min, maxProviderTypes: max }),
  reset: () => set(initialState),
}));
